import { useState, useCallback } from "react";
import { toast } from "react-toastify";

const ErrorNotifier = ({ children }) => {
  const [error, setError] = useState(false);
  const showError = useCallback((error) => setError(error), []);

  if (error) toast.error(error);

  return children(showError);
};

export default ErrorNotifier;
